/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_PasteInputs */



/**
* | output |
* | --- |
* | "Paste event or text" |
*
* @param {Shortcut_Keys_Desc_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_paste = /** @type {((inputs?: Shortcut_Keys_Desc_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller l'evenement ou le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis oder Text einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla evento o testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте событие или текст.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar evento o texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴事件或文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントまたはテキストを貼り付ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट या टेक्स्ट पेस्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cole o evento ou o texto.")
	return /** @type {LocalizedString} */ ("Paste event or text")
});